import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React from "react";
import { WorkshopDto, WorkshopInstanceDto } from "../../../types/workshopTypes";
import dayjs from "dayjs";

interface DeleteWorkshopInstanceDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  workshopInstance: WorkshopInstanceDto;
  workshop: WorkshopDto;
}

const DeleteWorkshopInstanceDialog = ({
  open,
  onClose,
  onDelete,
  workshopInstance,
  workshop,
}: DeleteWorkshopInstanceDialogProps) => {
  const handleDeleteCancel = () => {
    onClose();
  };

  const handleDelete = () => {
    onDelete();
  };

  return (
    <Dialog open={open} onClose={handleDeleteCancel}>
      <DialogTitle>Workshop-Termin löschen</DialogTitle>
      <DialogContent>
        <Typography>
          Bist du sicher, dass du den Workshop-Termin am {dayjs(workshopInstance.date).format("DD.MM.YYYY")} "
          {workshop.workshopName}" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteCancel}>Abbrechen</Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteWorkshopInstanceDialog;
